
import React from 'react';
import { Music, MessageCircle, Phone, Mail, Instagram, Facebook, MapPin, Headphones } from 'lucide-react';
import QRCodeGenerator from '../common/QRCodeGenerator';
import MapComponent from '../common/MapComponent';

const MusicLinktree = () => {
  const socialLinks = [
    { icon: Instagram, url: "https://www.instagram.com/decidedigitaloficial" },
    { icon: Facebook, url: "https://www.facebook.com/decidedigitaloficial" },
  ];

  const mainLinks = [
    {
      icon: Music,
      title: "Streaming",
      subtitle: "Ouça nossas músicas",
      url: "https://decidedigital.com.br/",
      gradient: "from-pink-500 via-red-500 to-yellow-500"
    },
    {
      icon: Headphones,
      title: "Shows & Eventos",
      subtitle: "Próximas apresentações",
      url: "https://decidedigital.com.br/",
      gradient: "from-purple-500 to-pink-600"
    },
    {
      icon: MessageCircle,
      title: "Contato Artístico",
      subtitle: "Colaborações e shows",
      url: "https://wa.me/5569992083972?text=Ol%C3%A1%20gostaria%20de%20contratar%20para%20um%20evento",
      gradient: "from-green-500 to-emerald-600"
    },
    {
      icon: Phone,
      title: "Empresário",
      subtitle: "(69) 99208-3972",
      url: "tel:+5569992083972",
      gradient: "from-blue-500 to-indigo-600"
    },
    {
      icon: Mail,
      title: "E-mail",
      subtitle: "contato@decidedigital.com.br",
      url: "mailto:contato@decidedigital.com.br",
      gradient: "from-indigo-500 to-purple-600"
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-900 via-pink-900 to-red-900 py-8 px-4 relative overflow-hidden">
      {/* Animated Background */}
      <div className="absolute inset-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-pink-500/20 rounded-full blur-xl animate-pulse"></div>
        <div className="absolute bottom-32 right-8 w-24 h-24 bg-purple-500/20 rounded-full blur-lg animate-bounce"></div>
      </div>

      <div className="max-w-md mx-auto relative z-10">
        {/* Profile Section */}
        <div className="text-center mb-8 animate-fade-in">
          <div className="w-32 h-32 mx-auto mb-4 bg-gradient-to-br from-pink-400 via-purple-500 to-indigo-600 rounded-full flex items-center justify-center shadow-2xl">
            <Music className="w-16 h-16 text-white" />
          </div>
          <h1 className="text-4xl font-bold bg-gradient-to-r from-pink-400 to-purple-400 bg-clip-text text-transparent mb-2">
            SoundWave
          </h1>
          <p className="text-pink-200 leading-relaxed px-4 text-sm">
            🎵 Artista independente criando músicas que tocam o coração. 
            Acompanhe nossa jornada musical e venha vibrar conosco! 🎶
          </p>
        </div>

        {/* QR Code for Music */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-4 mb-6 text-center animate-scale-in">
          <p className="text-white text-sm mb-3">🎧 Playlist Completa:</p>
          <div className="flex justify-center">
            <QRCodeGenerator url="https://decidedigital.com.br/" size={100} />
          </div>
        </div>

        {/* Social Icons */}
        <div className="flex justify-center space-x-4 mb-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="w-16 h-16 bg-white/10 backdrop-blur-sm rounded-full flex items-center justify-center hover:bg-white/20 transition-all duration-300 hover:scale-110 hover:rotate-12 animate-scale-in"
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <social.icon className="w-6 h-6 text-white" />
            </a>
          ))}
        </div>

        {/* Main Links */}
        <div className="space-y-4">
          {mainLinks.map((link, index) => (
            <a
              key={index}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`block w-full p-5 bg-gradient-to-r ${link.gradient} rounded-3xl text-white shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-105 hover:rotate-1 animate-fade-in`}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="flex items-center">
                <div className="w-16 h-16 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center mr-4">
                  <link.icon className="w-8 h-8" />
                </div>
                <div className="flex-1">
                  <div className="font-bold text-xl">{link.title}</div>
                  <div className="text-sm opacity-90">{link.subtitle}</div>
                </div>
                <Music className="w-6 h-6 opacity-70" />
              </div>
            </a>
          ))}
        </div>

        {/* Studio Location */}
        <div className="bg-white/10 backdrop-blur-sm rounded-3xl p-4 mt-6 animate-fade-in">
          <p className="text-white text-sm mb-3 text-center font-medium">🎙️ Estúdio de Gravação:</p>
          <MapComponent latitude={-8.7619} longitude={-63.9019} zoom={16} />
        </div>
      </div>
    </div>
  );
};

export default MusicLinktree;
